import { createContext } from "react";

const popUpContext = createContext();

export default popUpContext;